import { stringify } from 'query-string';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Page } from '@atlassian/jira-shared-types/src/rest/jira/page.tsx';
import type { Sprint } from '../../model/index.tsx';

const getActiveSprints = (boardId: string): Promise<Page<Sprint>> => {
	const params = stringify({
		state: 'active',
	});

	return fetchJson(`/rest/agile/1.0/board/${boardId}/sprint?${params}`);
};

export default getActiveSprints;
